export const messages = {
  en: {
    printAssetInventoryInStock: {
      inventoryName: 'Inventory Name',
      inventoryPerson: 'Inventory Person',
      warehouse: 'Warehouse',
      inventoryDate: 'Inventory Date',
      warehouseName: 'Warehouse Name',
      itemType: 'Item Type',
      itemName: 'Item Name',
      specification: 'Specification',
      itemCode: 'Item Code',
      isFixed: 'Is Fixed',
      batchPrice: 'Batch Price',
      originalStock: 'Original Stock',
      afterInventory: 'After Inventory',
      remark: 'Remark',
      warehouseManagerSign: 'Warehouse Manager Sign',
      transferPersonSign: 'Transfer Person Sign',
      time: 'Time'
    }
  },
  zh: {
    printAssetInventoryInStock: {
      inventoryName: '盘点名称',
      inventoryPerson: '盘点人',
      warehouse: '选择仓库',
      inventoryDate: '盘点日期',
      warehouseName: '仓库名称',
      itemType: '物品类型',
      itemName: '物品名称',
      specification: '物品规格',
      itemCode: '物品编码',
      isFixed: '是否是固定物品',
      batchPrice: '批次价格',
      originalStock: '原有库存',
      afterInventory: '盘点后数量',
      remark: '备注',
      warehouseManagerSign: '仓库管理员签字',
      transferPersonSign: '调拨人员签字',
      time: '时间'
    }
  }
}